import { render, staticRenderFns } from "./EditorialViewer.vue?vue&type=template&id=56beb8d6&"
import script from "./EditorialViewer.vue?vue&type=script&lang=js&"
export * from "./EditorialViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports